import { AfterViewInit, Directive, ElementRef, EventEmitter, HostListener, OnInit, Output } from "@angular/core";
import { CoreCOMService } from "../../services/com.service";
import { CoreLanguageService } from "../../services/language.service";
import * as _ from "lodash";

const DEFAULT_FONT_SIZE = 20;

@Directive({
  selector: "[artikleLabelHeight]"
})
export class ArtikleLabelHeightDirective implements OnInit, AfterViewInit {

  private resizeFunc =  _.debounce(this.recalculateHeight, 100);
  constructor(private _el: ElementRef) {

  }
  ngAfterViewInit(): void {
    const me = this;
    me.checkLabelHeight();
  }

  ngOnInit(): void {

  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.resizeFunc();
  }

  private checkLabelHeight() {
    const me = this;
    const productLabelContent = (me._el.nativeElement as HTMLElement).querySelector(".product-label-content") as HTMLElement;
    if (productLabelContent.scrollHeight > productLabelContent.clientHeight) {
      const title = (me._el.nativeElement as HTMLElement).querySelector(".product-label-content>h3") as HTMLElement;
      me.setLabelHeight(DEFAULT_FONT_SIZE, productLabelContent, title);
    }
  }

  private recalculateHeight() {
    const me = this;
    const productLabelContent = (me._el.nativeElement as HTMLElement).querySelector(".product-label-content") as HTMLElement;
    const title = (me._el.nativeElement as HTMLElement).querySelector(".product-label-content>h3") as HTMLElement;
    this.setLabelHeight(DEFAULT_FONT_SIZE, productLabelContent, title);
  }

  private setLabelHeight(size: number = null, productLabelContent: HTMLElement, title: HTMLElement) {
    const me = this;

    if (size <= 0) {
      console.error("setLabelHeight recursive 0");
      return;
    }
    title.style.fontSize = (size - 1) + "px";
    title.style.lineHeight = size + "px";

    if (productLabelContent.scrollHeight > productLabelContent.clientHeight) {
      me.setLabelHeight(size - 2, productLabelContent, title);
    }

    // if (productLabelContent.clientHeight + 18 < title.clientHeight) {// 22 --> 12 for margin and 10 more for very long word with longer height
    //   title.style.fontSize = "12px";
    //   title.style.lineHeight = "14px";
    // } else if (productLabelContent.clientHeight + 6 < title.clientHeight) {// 12 --> 12 for margin
    //   title.style.fontSize = "14px";
    //   title.style.lineHeight = "16px";
    // } else {
    //   // do nothing
    // }
  }
}
